import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Dialog, Stack, TextField, Typography } from "@mui/material";
import { axiosAPI } from "../../Axios/Axios";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { errorNotify, succesNotify } from "../../CommonCode/Commonfunc";
import Country from "../../CommonCode/Country";
import State from "../../CommonCode/State";
import TextfieldCustom from "../../Components/TextfieldCustom";
import { useSelector } from "react-redux";
import { useState } from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "60%",
    sm: "50%",
    md: "40%",
    lg: "30%",
  },
  bgcolor: "#FFFFFF",
  boxShadow: 24,
  p: 4,
  borderRadius: "8px",
};

export default function PreferedLocationModal({ open, handleClose, data }) {
  const [isButtonDisable, setButtonDisable] = useState(false);
  const [place, setLocations] = useState(data);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [userchangedcountry, setuserchangedcountry] = useState(null);
  const [city, setCity] = useState("");
  const submitLocations = async () => {
    if (!country || !state || !city) {
      return errorNotify(Labels.allFieldsMandatory);
    } else if (city.length > 200) {
      errorNotify(Labels.cityValidation);
    } else {
      setButtonDisable(true);
      const newData = {
        countryid: country.id,
        stateid: state.id,
        city: city,
      };
      place.push(newData);
      const postData = {
        locations: JSON.stringify(place),
        language: localStorage.getItem("language"),
      };
      const result = await axiosAPI.post("/updateUserProfile", postData);
      const { success, message } = result.data;
      if (success === true) {
        succesNotify(message);
        handleClose();
        setButtonDisable(false);
      } else {
        errorNotify(message);
        setButtonDisable(false);
      }
    }
  };
  const Labels = useSelector((state) => state.allLabels.labels);
  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ p: 1.5 }}
      >
        <Typography variant="h6" sx={{ color: "#005F8E" }}>
          {Labels?.PreferredLocations}
        </Typography>
        <HighlightOffIcon
          sx={{
            color: "#005F8E",
            cursor: "pointer",
          }}
          onClick={handleClose}
        />
      </Stack>
      <Box sx={{ p: 1.5 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {Labels?.Country}
        </Typography>
        <Country
          value={country}
          setValue={setCountry}
          setStateId={setState}
          userchangedcountry={userchangedcountry}
          setuserchangedcountry={setuserchangedcountry}
          style={{
            width: "100%",
            borderColor: "#106995",
            "& .MuiOutlinedInput-root": {
              padding: "0px",

              "& fieldset": {
                borderColor: "#106995", // Change border color
              },
              "&:hover fieldset": {
                borderColor: "#000000", // Change border color on hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#106995", // Change border color when focused
              },
            },
          }}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {Labels?.State}
        </Typography>
        <State
          value={state}
          setValue={setState}
          country={country}
          userchangedcountry={userchangedcountry}
          setuserchangedcountry={setuserchangedcountry}
          style={{
            width: "100%",
            borderColor: "#106995",
            "& .MuiOutlinedInput-root": {
              padding: "0px",

              "& fieldset": {
                borderColor: "#106995", // Change border color
              },
              "&:hover fieldset": {
                borderColor: "#000000", // Change border color on hover
              },
              "&.Mui-focused fieldset": {
                borderColor: "#106995", // Change border color when focused
              },
            },
          }}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
          {Labels?.City}
        </Typography>
        <TextfieldCustom
          style={{
            width: "100%",
          }}
          label={Labels?.City}
          onChange={(e) => setCity(e.target.value)}
        />
        <Stack direction="row" justifyContent="center" sx={{ p: 1.5 }}>
          <Button
            variant="solid"
            fullWidth
            sx={{
              background: "#005F8E",
              borderRadius: 3,
              color: "#fff",
              "&:hover": {
                backgroundColor: "#005F8E",
              },
              "&:active": {
                backgroundColor: "#005F8E",
              },
              "&:disabled": { color: "white", backgroundColor: "#005F8E" },
            }}
            disabled={isButtonDisable}
            onClick={submitLocations}
          >
            {Labels?.Save}
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
}
